<section id="sInsuranceList" class="py-8">
  <div class="common-container">
    <div class="css-grid">
      <ng-template
        ngFor
        let-element
        [ngForOf]="sectionInsuranceList"
        let-i="index"
        let-isFirst="first">
        <p-card header="{{ element.translation }}">
          <ng-template pTemplate="header">
            <a [routerLink]="['/seguro-buceo/' + element.route]">
              <img
                class="product-image img-{{ element.translation }}"
                src="assets/img/product/640/{{ element?.image_url }}"
                [alt]="element.name" />
            </a>
          </ng-template>

          <ng-template pTemplate="footer">
            <div class="flex gap-3 mt-1">
              <p-button
                i18n-label="@@featured-insurance.button.see-insurances"
                label="Ver seguros"
                class="w-full"
                styleClass="w-full"
                [routerLink]="['/seguro-buceo/' + element.route]" />
            </div>
          </ng-template>
        </p-card>
      </ng-template>
    </div>
  </div>
</section>
